export default "__VITE_ASSET__CMt7SOJA__"